import styled from "styled-components";

export const Search = styled.div`
  input {
    padding: 8px 9px;
    width: 250px;
    border-radius: 5px;
    border: 0;
    outline: 0;
    font-size: 1rem;
  }

  input[type="search"] {
    -webkit-appearance: none;
  }
`;
